const BUFFER_KM = 60;
let data = null;

export const loadNorway = () =>
  data
    ? Promise.resolve(data)
    : Promise.all([import("@/data/norway.json"), import("@/data/neighbours.json")]).then(([n, b]) => {
        data = { polys: n.default, neighbours: b.default };
        return data;
      });

const inside = (lng, lat, ring) => {
  let hit = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if (yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) hit = !hit;
  }
  return hit;
};

const near = (lng, lat, ring) => {
  const kx = 111.32 * Math.cos((lat * Math.PI) / 180);
  const px = lng * kx;
  const py = lat * 110.57;
  for (let i = 0; i < ring.length - 1; i++) {
    const ax = ring[i][0] * kx, ay = ring[i][1] * 110.57, bx = ring[i + 1][0] * kx, by = ring[i + 1][1] * 110.57;
    const dx = bx - ax, dy = by - ay;
    const len = dx * dx + dy * dy;
    const t = len ? Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / len)) : 0;
    if (Math.hypot(px - (ax + t * dx), py - (ay + t * dy)) <= BUFFER_KM) return true;
  }
  return false;
};

// Same rule as the backend: inside Norway, or near its coast but not inside Sweden, Finland or Russia.
export const inNorway = ({ lat, lng }) => {
  if (!data) return true;
  if (data.polys.some((r) => inside(lng, lat, r))) return true;
  if (data.neighbours.some((r) => inside(lng, lat, r))) return false;
  return data.polys.some((r) => near(lng, lat, r));
};

export const toOutline = (d) => d.polys.map((ring) => ring.map(([lng, lat]) => [lat, lng]));
